import { Notification0 } from "../../../../src/components/images/support/users/Notification0.generated";
import { Notification1 } from "../../../../src/components/images/support/users/Notification1.generated";
import { Notification2 } from "../../../../src/components/images/support/users/Notification2.generated";
import * as React from 'react';
export default {
  Notification0,
  Notification1,
  Notification2,
  React
};